<template>
	<v-card flat>
		<v-card-text class="pa-0" :class="{'is-error': isError}">
			<div v-if="title" class="v-label v-label--active theme--light pb-1">{{ title }}</div>
			<editor
				ref="editor"
				v-model="internalValue"
				:api-key="apiKey"
				:init="options"
				:rules="rules"
				@onInit="handleInit"
				@input="updateValue"
			></editor>

			<div v-if="limit" class="v-text-field__details">
				<div class="v-messages theme--light" role="alert">
					<div class="v-messages__wrapper">
						<div v-if="isError" class="v-messages__message" :class="{'error--text': isError}">
							يجب ان لا يزيد عن {{ limit }} رمز
						</div>
					</div>
				</div>
				<div class="v-counter theme--light" :class="{'error--text': isError}">
					{{ internalValue.length }} / {{ limit }}
				</div>
			</div>
			
			<div v-if="!loaded">جاري تحميل المحرر</div>
		</v-card-text>
	</v-card>
</template>

<script>
import Editor from "@tinymce/tinymce-vue";

export default {
	components: {
		editor: Editor
	},
	props: {
		value: {
			type: String,
			default: ""
		},
		rules: {
			type: Array,
			default: () => []
		},
		limit: {
			type: Number,
			default: 0
		},
		toolbar: {
			type: String,
			default:
				"bold italic underline | formatselect | alignleft aligncenter alignright alignjustify | forecolor backcolor | bullist numlist outdent indent | link image table | undo redo removeformat"
		},
		title: {
			type: String,
			default: ""
		},
		hideMenu: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			internalValue: "",
			loaded: false,
			apiKey: "vbg3mj0p7eksu7ncx0alpcgka3gpwo3oysr1qqk6ta69tzkv",
			options: {
				directionality: "rtl",
				language: "ar",
				language_url: "/tinymce/langs/ar.js",
				theme: "silver",
				min_height: 300,
				height: 500,
				menubar: !this.hideMenu,
				plugins: [
					"advlist autolink lists link image charmap print preview anchor",
					"searchreplace visualblocks code fullscreen",
					"insertdatetime media table paste code"
				],
				entity_encoding: "raw",
				element_format : 'html',
				toolbar: this.toolbar,
				toolbar_drawer: "floating",
				paste_auto_cleanup_on_paste : true,
				paste_postprocess : function(pl, o) {
					// remove &nbsp;
					o.node.innerHTML = o.node.innerHTML.replace(/&nbsp;/ig, " ");
				}
			}
		};
	},
	computed: {
		isError() {
			if (this.limit) {
				if (this.internalValue.length > this.limit) {
					return true;
				}
			}
			return false;
		}
	},
	watch: {
		value(newVal) {
			this.internalValue = newVal;
		}
	},
	mounted() {
		this.internalValue = this.value;
	},
	methods: {
		handleInit() {
			this.loaded = true;
		},
		updateValue() {
			// remove &nbsp;
			this.internalValue = this.internalValue.replace(/&nbsp;/ig, " ")
			this.$emit("input", this.internalValue);
		}
	}
};
</script>

<style scoped>
div ::v-deep .tox {
	border-radius: 4px;
	border-color: #9e9e9e;
}

.is-error ::v-deep .tox {
	border: 2px solid;
	border-color: red;
}
</style>
